__turbopack_context__.v({
  "sticky-cta-bar": "StickyCtaBarBlock-module-scss-module__WgI9cW__sticky-cta-bar",
  "sticky-cta-bar-bounds": "StickyCtaBarBlock-module-scss-module__WgI9cW__sticky-cta-bar-bounds",
  "sticky-cta-bar__button": "StickyCtaBarBlock-module-scss-module__WgI9cW__sticky-cta-bar__button",
  "sticky-cta-bar__inner": "StickyCtaBarBlock-module-scss-module__WgI9cW__sticky-cta-bar__inner",
  "sticky-cta-bar__message": "StickyCtaBarBlock-module-scss-module__WgI9cW__sticky-cta-bar__message",
  "sticky-cta-bar__outer": "StickyCtaBarBlock-module-scss-module__WgI9cW__sticky-cta-bar__outer",
});
